import { render, staticRenderFns } from "./CustomerProfileView.vue?vue&type=template&id=367ca97f&scoped=true"
import script from "./CustomerProfileView.vue?vue&type=script&lang=js"
export * from "./CustomerProfileView.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfileView.vue?vue&type=style&index=0&id=367ca97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ca97f",
  null
  
)

export default component.exports